import { Avatar, Flex, HStack, VStack } from '@chakra-ui/react';
import { PropsWithChildren, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { TopMenu } from '../../../../packages/ui/components/organisms/TopMenu';
import { useProfile } from '../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../contexts/ThemeProvider';
import { IBottomMenuLink, BottomMenu } from '../components/organisms/BottomMenu';
import Home from '../assets/home.svg?react';
import Tag from '../assets/Tag.svg?react';
import Gift from '../assets/Gift.svg?react';
import Parter from '../assets/partner.svg?react';
import User from '../assets/user.svg?react';
import Notificacao from '../assets/Notificacao.svg?react';
import Grid from '../assets/Grid.svg?react';
import Mail from '../assets/Mail.svg?react';
import { FaShoppingCart } from 'react-icons/fa';
import { ScrollToTop } from '../utils';

export function MainTemplate({
  hideTopMenu = false,
  isNative = false,
  hideBottomMenu = false,
  noShadow = true,
  isIframeActive,
  children,
  goBack,
}: {
  isNative?: boolean;
  hideTopMenu?: boolean;
  hideBottomMenu?: boolean;
  noShadow?: boolean;
  isIframeActive?: boolean;
  goBack?: () => void;
} & PropsWithChildren) {
  const theme = useTheme();

  const { metadata } = theme || {};
  const checkUrl = () => {
    if (theme?.customerCentralModule) return true;

    return false;
  };

  const { profile } = useProfile();
  const links = useMemo<IBottomMenuLink[]>(
    () =>
      profile
        ? [
            { name: 'Home', icon: <Home />, path: '/' },
            { name: 'Descontos', icon: <Tag />, path: '/vantagens' },
            { name: metadata?.benefitsname || 'Benefícios', icon: <Gift />, path: '/beneficios' },
            { name: 'Compras', icon: <FaShoppingCart size={25} />, path: '/historico' },
            ...(checkUrl() ? [{ name: 'Central do Cliente', icon: <Grid />, path: '/central-do-cliente' }] : []),
            { name: 'Seja um parceiro', icon: <Gift />, path: '/parcerias', hide: true },
          ]
        : [
            { name: 'Home', icon: <Home />, path: '/' },
            { name: metadata?.benefitsname || 'Benefícios', icon: <Gift />, path: '/beneficios' },
            { name: 'Seja um parceiro', icon: <Parter width={25} height={25} />, path: '/parcerias' },
            { name: 'Contato', icon: <Mail />, path: '/contato', desktopName: 'Fale Conosco', hide: true },
            { name: 'Login', icon: <User />, path: '/login' },
          ],
    [profile]
  );
  const basePaddingTop = useMemo(() => {
    let result = 0;
    if (!hideTopMenu) result += isNative ? 30 : 60;

    return result + 'px';
  }, [hideTopMenu, theme]);

  return (
    <>
      <ScrollToTop />
      <Flex zIndex={100} pos={'fixed'} display={{ base: hideTopMenu ? 'none' : 'flex', lg: 'flex' }}>
        <TopMenu
          {...theme}
          colors={theme.colors}
          noShadow={noShadow}
          links={links.map((l) => ({
            display: l.desktopName || l.name,
            icon: l.icon,
            path: l.path,
            showOnTopMenu: true,
          }))}
          goBack={goBack}
          menuHeight={isNative ? '30px' : '60px'}
          avatarComponent={
            <HStack>
              <Link
                style={{
                  zIndex: 200,
                }}
                to="/notificacoes"
              >
                <Notificacao
                  color={theme.colors.primaryColor}
                  style={{
                    width: '30px',
                    height: '30px',
                  }}
                />
              </Link>
              <Link to="/perfil">
                <Avatar boxSize={isNative ? '25px' : '36px'} src={profile?.image} />
              </Link>
            </HStack>
          }
          logoCenter
          isNative={isNative}
          logoWidth={isNative ? '30px' : '35px'}
          backgroundColor={'#F1F4F5'}
        ></TopMenu>
      </Flex>
      <VStack
        maxWidth={{
          base: '100%',
          sm: '100%',
          lg: '1264px',
        }}
        paddingX={{ base: '0px', lg: '20px' }}
        margin="auto"
        paddingTop={{ base: basePaddingTop, lg: '60px' }}
        overflowY={'visible'}
        display={'flex'}
      >
        {children}
      </VStack>
      {!hideBottomMenu && <BottomMenu isIframeActive={isIframeActive} links={links.filter((l) => !l.hide)} />}
    </>
  );
}
